class FileController {
  constructor(HttpService){
    'ngInject';

    this.HttpService = HttpService;
  }
}

export default FileController;



// WEBPACK FOOTER //
// ./client/app/pages/profile/component/file.controller.js